"use client";

import Link from "next/link";
import Image from "next/image";
import Button from "@/components/ui/Button";
import UserMenu from "./UserMenu";
import { useAuthUser } from "@/hooks/useAuthUser";

import Logo from "../../public/logo.svg";

export default function Header() {
  const { isAuthenticated } = useAuthUser();

  const getHomeUrl = () => (isAuthenticated ? "/conecta" : "/");

  const getNavLinks = () => [
    { label: "Início", href: getHomeUrl() },
    { label: "Categorias", href: "/categorias" },
    { label: "Empresas", href: "/empresas" },
    { label: "Eventos", href: "/eventos" },
    { label: "Contato", href: "/contato" },
  ];

  return (
    <header className="sticky top-0 left-0 right-0 z-50 py-6 bg-main">
      <div className="container">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <Link href={getHomeUrl()} className="shrink-0">
              <Image src={Logo} alt="Logo Santa Fé" loading="eager" priority />
            </Link>
          </div>

          <nav className="hidden md:flex items-center space-x-8">
            {getNavLinks().map((link) => (
              <Link
                key={link.href}
                href={link.href}
                className="text-white hover:text-white/90 font-medium transition-colors"
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center justify-end gap-2">
            {isAuthenticated ? (
              <UserMenu />
            ) : (
              <>
                <Button
                  href="/login"
                  variant="text"
                  size="md"
                  className="px-2 text-white hover:text-white/90"
                >
                  Entrar
                </Button>

                <Button
                  href="/cadastro?tipo=empresa"
                  variant="secondary"
                  size="md"
                >
                  Cadastrar{" "}
                  <span className="hidden md:inline">Meu Negócio</span>
                </Button>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
